/**
 * Update qty mobile - sticky bottom
 */

function updateQtyMobile() {
	let qtyCart = '0';

	if (document.querySelector('.mobile-cart .cart-count-bubble')) {
		qtyCart = document.querySelector('.cart-count-bubble span:first-child').innerText;
	}

	if (document.querySelector('.bottom-mobile_items .cart-count-bubble span')) {
		document.querySelector('.bottom-mobile_items .cart-count-bubble span').innerHTML = qtyCart;
	}
}

/**
 * Move content to mobile
 */
function moveToMobile() {
	const contents = document.querySelectorAll('div[data-target-mobile]');

	contents.forEach((item) => {
		const targetMobileId = item.getAttribute('data-target-mobile');
		const htmlData = item.innerHTML;
		item.innerHTML = '';
		document.getElementById(targetMobileId).innerHTML = htmlData;
	});
}

/**
 * get height header
 */
function getHeaderHeight() {
	const headerHeight = document.querySelector('.tpt-header-group').offsetHeight;
	document.querySelector('.tpt-header-group').style = '--header-height: ' + headerHeight + 'px';
}

window.addEventListener('resize', function () {
	getHeaderHeight();
});

window.addEventListener('DOMContentLoaded', function () {
	/**
	 * Height header
	 */

	getHeaderHeight();

	if (window.innerWidth <= 1024) {
		moveToMobile();
	}

	moveSizeChartToBody();

	const documentWidth = document.body.clientWidth;
	const styleString = '--document-width:' + documentWidth + 'px';

	if (this.document.querySelector('.horizontal-items')) {
		this.document.querySelector('.horizontal-items').setAttribute('style', styleString);
	}
});

/**
 * Change form customer sidebar
 */
document.querySelectorAll('.change-form-customer').forEach((element) => {
	element.addEventListener('click', (event) => changeFormCustomer(event, element));
});

function changeFormCustomer(event, element) {
	event.preventDefault();
	const modalTitle = element.getAttribute('data-form-title');
	const modalTarget = element.getAttribute('data-form-customer-target');
	const currentModal = element.closest('tpt-modal-content');
	const formCustomers = currentModal.querySelectorAll('.customer-form');

	currentModal.querySelector('.modal-title').innerHTML = modalTitle;

	formCustomers.forEach((form) => {
		form.style.display = 'none';
	});

	document.getElementById(modalTarget).style.display = 'block';
	document.getElementById(modalTarget).focus();
}

/**
 * Set top position modal search
 */
window.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('.header-desktop')) {
		let headerDesktopHeight = document.querySelector('.header-desktop').offsetHeight;
		document.querySelector('.header-desktop .search-modal').style.top = headerDesktopHeight + 'px';
	}
});
/**
 * Section lady load
 */
function secsionLadyLoad() {
	let parentSection = '';
	const section = document.querySelector('[data-ladyload="true"]');

	if (section) {
		parentSection = section.closest('.shopify-section');
	}

	if (section) {
		const elementId = section.getAttribute('id');
		const sectionId = elementId.substring(16);
		const urlFetchSectionId = window.Shopify.routes.root + '?section_id=' + sectionId;

		if (!section.classList.contains('loaded')) {
			section.classList.add('loaded');

			fetch(urlFetchSectionId)
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					setTimeout(() => {
						sectionElement = responseHTML.querySelector('section[id^="shopify-section-"]');

						section.innerHTML = sectionElement.innerHTML;
						section.querySelectorAll('script').forEach((oldScriptTag) => {
							const newScriptTag = document.createElement('script');
							Array.from(oldScriptTag.attributes).forEach((attribute) => {
								newScriptTag.setAttribute(attribute.name, attribute.value);
							});
							newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
							oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
						});

						section.setAttribute('data-ladyload', 'false');

						/**
						 * Fix lazyload image with RTL layout
						 */
						if (parentSection && document.querySelector('body').classList.contains('layout-rtl')) {
							const imagesLazy = parentSection.querySelectorAll('img');

							imagesLazy.forEach((image) => {
								if (image.getAttribute('loading') == 'lazy') {
									image.setAttribute('loading', 'loaded');
								}
							});
						}
					}, 50);
				})
				.finally(() => {
					if (document.querySelector('[data-fancybox]')) {
						Fancybox.bind('[data-fancybox="gallery"]', {});
					}
				});
		}
	}
}

let defaultDocumentTop = 0;
const headerMobileTop = document.querySelector('.header-mobile').offsetTop;

function stickyHeaderMobile() {
	const headerMobile = document.querySelector('.header-mobile');
	const colorOnSlideshow = document.querySelector('.header-main-mobile').getAttribute('data-group-color');
	let currentDocumentTop = document.documentElement.scrollTop;

	if (currentDocumentTop < defaultDocumentTop && currentDocumentTop > headerMobileTop) {
		headerMobile.classList.add('header-mobile-sticky');

		if (document.body.classList.contains('index')) {
			headerMobile.querySelector('.header-main-mobile').classList.remove(colorOnSlideshow);
		}

		defaultDocumentTop = currentDocumentTop;
		return;
	} else {
		headerMobile.classList.remove('header-mobile-sticky');

		if (document.body.classList.contains('index')) {
			headerMobile.querySelector('.header-main-mobile').classList.add(colorOnSlideshow);
		}

		defaultDocumentTop = currentDocumentTop;
		return;
	}
}

document.addEventListener('scroll', (event) => {
	secsionLadyLoad();
	stickyHeaderMobile();
});

/**
 * Fix image lazyload with swipper slider and RTL layout
 */

const interSection = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.intersectionRatio > 0) {
			entry.target.querySelectorAll('img').forEach((image) => {
				if (image.getAttribute('loading') == 'lazy') {
					image.setAttribute('loading', 'loaded');
				}
			});
		}
	});
});

if (document.querySelector('body').classList.contains('layout-rtl')) {
	const swiperSlider = document.querySelectorAll('tpt-slider-component');

	swiperSlider.forEach((slider) => {
		interSection.observe(slider);
	});
}

/**
 * End fix image lazyload with swipper slider
 */

/**
 * Dropdown megamenu mobile
 */

class DropdownMegamenuMobile extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.showDropdownMegamenuMobile.bind(this));
	}

	showDropdownMegamenuMobile() {
		const btnDropdown = this;
		const menuItem = btnDropdown.closest('.menu-item');
		menuItem.classList.add('show-dropdown');

		setTimeout(function () {
			menuItem.classList.add('animate');
		}, 10);
	}
}

customElements.define('dropdown-megamenu-item', DropdownMegamenuMobile);

class BackDropdownMegamenu extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', this.backToMegamenuItem.bind(this));
	}

	backToMegamenuItem() {
		const btnBack = this;
		const menuItem = btnBack.closest('.menu-item');
		menuItem.classList.remove('animate');

		setTimeout(function () {
			menuItem.classList.remove('show-dropdown');
		}, 300);
	}
}

customElements.define('back-to-item', BackDropdownMegamenu);

/**
 * Sticky product add to cart
 */
class StickyProductAddToCart extends HTMLElement {
	constructor() {
		super();

		const btnChangeQty = this.querySelectorAll('.quantity__button');
		const btnStickyAddCart = this.querySelector('.sticky-add-cart');
		const quantityInput = this.querySelector('[name="quantity"]');
		quantityInput.addEventListener('input', this.syncQuantity.bind(this));
		quantityInput.addEventListener('change', this.syncQuantity.bind(this));

		btnStickyAddCart.addEventListener('click', this.addToCart);

		btnChangeQty.forEach((btn) => {
			btn.addEventListener('click', this.changeQty);
		});
	}

	syncQuantity() {
		const inputQty = this.querySelector('[name="quantity"]');
		const mainInput = document.querySelector('product-info quantity-input [name="quantity"]');
		if (mainInput && inputQty.validity.valid) {
			mainInput.value = inputQty.value;
			mainInput.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}

	changeQty() {
		const inputQty = this.closest('tpt-quantity-input').querySelector('[name="quantity"]');
		const mainInput = document.querySelector('product-info quantity-input [name="quantity"]');
		let stickyInputValue = parseInt(inputQty.value);

		if (this.getAttribute('name') == 'plus') {
			stickyInputValue = stickyInputValue + 1;
		} else {
			if (parseInt(inputQty.value) > 1) {
				stickyInputValue = stickyInputValue - 1;
			}
		}

		inputQty.value = stickyInputValue;
		mainInput.value = stickyInputValue;
	}

	addToCart() {
		this.classList.add('loading');
		document.querySelector('product-info product-form .product-form__submit').click();
	}
}

customElements.define('tpt-quantity-input', StickyProductAddToCart);

function showStickyAddCart() {
	let offsetTop = document.querySelector('product-info product-form').offsetTop;
	let documentTop = document.documentElement.scrollTop;
	const stickyAddCart = document.querySelector('.sticky-button-cart');

	if (documentTop > offsetTop + 400) {
		stickyAddCart.classList.add('active');
		document.body.classList.add('show-sticky-add-cart');
	} else {
		stickyAddCart.classList.remove('active');
		document.body.classList.remove('show-sticky-add-cart');
	}
}

document.addEventListener('scroll', (event) => {
	if (document.querySelector('.sticky-button-cart')) {
		showStickyAddCart();
	}
});

/**
 * Move modal sizechart to body
 */

function moveSizeChartToBody() {
	if (document.querySelector('[id="modal-size-chart"]')) {
		document.body.append(document.querySelector('[id="modal-size-chart"]'));
	}
}

/**
 * Back to top
 */

function toTop() {
	window.scrollTo({ top: 0, behavior: 'smooth' });
}

document.addEventListener('scroll', (event) => {
	const backToTop = document.querySelector('tpt-back-to-top');

	if (backToTop) {
		if (this.scrollY > 800) {
			backToTop.classList.add('active');
		} else {
			backToTop.classList.remove('active');
		}
	}
});

class BackToTop extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', toTop);
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			toTop();
		}
	}
}

customElements.define('tpt-back-to-top', BackToTop);

/**
 * Sticky header
 */

let offsetTopHeader = 0;
const sectionHeader = document.querySelector('.section-header');
sectionHeader.style = '--main-header-height: ' + sectionHeader.offsetHeight + 'px';

if (document.querySelector('[data-header-sticky="true"]')) {
	offsetTopHeader = document.querySelector('[data-header-sticky="true"]').offsetTop;
}

document.addEventListener('scroll', (event) => {
	const btnNewsletterPopup = document.querySelector('.newsletter-popup_button');
	const stickyBottomMenu = document.querySelector('.sticky-bottom-mobile');
	const windowHeight = window.innerHeight;

	if (this.scrollY > windowHeight) {
		if (btnNewsletterPopup) {
			btnNewsletterPopup.classList.add('active');
		}

		if (stickyBottomMenu) {
			document.body.classList.add('sticky-menu-bottom-active');
		}
	} else {
		if (btnNewsletterPopup) {
			btnNewsletterPopup.classList.remove('active');
		}

		if (stickyBottomMenu) {
			document.body.classList.remove('sticky-menu-bottom-active');
		}
	}

	if (document.querySelector('[data-header-sticky="true"]')) {
		const headerMain = document.querySelector('.header-main');
		const headerMainContent = document.querySelector('.header-main__content');
		const classStickyOnTopColor = headerMain.getAttribute('data-group-color');

		if (this.scrollY >= offsetTopHeader) {
			sectionHeader.classList.add('sticky-header');

			if (document.body.classList.contains('index') && classStickyOnTopColor) {
				headerMainContent.classList.remove(classStickyOnTopColor);
			}
		} else {
			sectionHeader.classList.remove('sticky-header');

			if (document.body.classList.contains('index') && classStickyOnTopColor) {
				headerMainContent.classList.add(classStickyOnTopColor);
			}
		}
	}
});

var headerMainContainer = document.querySelector('.header-main');
var headerMainContent = document.querySelector('.header-main__content');

headerMainContainer.addEventListener('mouseover', headermainMouseOver);
headerMainContainer.addEventListener('mouseout', headermainMouseOut);

const headerMainColorSticky = headerMainContainer.getAttribute('data-group-color');

function headermainMouseOver() {
	if (!document.querySelector('.sticky-header') && document.body.classList.contains('index') && headerMainColorSticky) {
		headerMainContainer.classList.add('mouse-over');
		headerMainContent.classList.remove(headerMainColorSticky);
	}
}

function headermainMouseOut() {
	if (!document.querySelector('.sticky-header') && document.body.classList.contains('index') && headerMainColorSticky) {
		headerMainContainer.classList.remove('mouse-over');
		headerMainContent.classList.add(headerMainColorSticky);
	}
}

/**
 * FAQs group
 */

class GroupFaqs extends HTMLElement {
	constructor() {
		super();

		const faqSections = document.querySelectorAll('.tpt-faqs');

		faqSections.forEach((faqSection) => {
			const groupTitle = faqSection.querySelector('.faq-group-title').innerHTML;
			this.insertAdjacentHTML('beforeend', groupTitle);
		});
	}
}

customElements.define('tpt-group-faqs', GroupFaqs);

class FaqGroupItem extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.scrollToFaqs.bind(this));
		this.addEventListener('keypress', this.keyPress);
	}

	keyPress(e) {
		if (e.key === 'Enter') {
			this.scrollToFaqs();
		}
	}

	scrollToFaqs() {
		const faqSectionId = this.getAttribute('data-section-id');
		const faqTop = document.getElementById(faqSectionId).offsetTop;
		let fixOffsetTop = 0;

		if (window.innerWidth >= 1024) {
			fixOffsetTop = 60;
		}
		window.scrollTo({
			top: faqTop - fixOffsetTop,
			behavior: 'smooth',
		});
	}
}

customElements.define('faq-group-item', FaqGroupItem);

/**
 * View more
 */
class ViewMore extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.viewMore.bind(this));
	}

	viewMore() {
		this.classList.toggle('active');
		this.closest('.has-more').classList.toggle('active');
	}
}

customElements.define('tpt-viewmore', ViewMore);

/**
 * Close newsletter
 */
class CloseNewsletter extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  this.tab = this.closest('.newsletter-popup_button');
  this.hide = () => { this.tab.hidden = true; this.tab.classList.remove('feminine-newsletter-ready'); };
  this.hide();
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const subscribed = this.tab.dataset.subscribed === 'true' || document.querySelector('[data-feminine-newsletter-success]');
  if (subscribed) { try { localStorage.setItem('feminineNewsletterSubscribed', 'true'); } catch {} }
  if (!subscribed && read('feminineNewsletterSubscribed') !== 'true' && Number(read('feminineNewsletterDismissedUntil') || 0) < Date.now()) {
   this.timer = setTimeout(() => { this.tab.hidden = false; this.tab.classList.add('feminine-newsletter-ready'); }, 15000);
  }
  this.dismiss = () => { clearTimeout(this.timer); this.hide(); try { localStorage.setItem('feminineNewsletterDismissedUntil', String(Date.now() + 7 * 24 * 60 * 60 * 1000)); } catch {} };
  this.addEventListener('click', this.dismiss);
  this.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); this.dismiss(); } });
  this.modalClose = document.querySelector('#tpt-modal-newsletter [data-close="modal"]');
  this.modalClose?.addEventListener('click', this.dismiss);
 }
 disconnectedCallback() { clearTimeout(this.timer); this.modalClose?.removeEventListener('click', this.dismiss); }
}

customElements.define('tpt-close-newsletter', CloseNewsletter);

/**
 * Upsell minicart
 */

function upsellNoProduct() {
	const noProductData = '<div class="upsell-no-product">' + window.upsellProduct.noProduct + '</div>';
	const upsellCartContent = document.getElementById('upsell-ajax-load');
	const upsellcartBottom = document.getElementById('cart-drawer_upsell-bottom');

	if (upsellCartContent) {
		upsellCartContent.innerHTML = noProductData;
	}

	upsellcartBottom.innerHTML = noProductData;
}

function upsellCartDrawer() {
	const lastIdProductAdded = localStorage.getItem('lastProductAdded');

	const urlRecommend = document.querySelector('cart-drawer').getAttribute('data-recommendations-url');
	const upsellCartUrl = urlRecommend + '&product_id=' + lastIdProductAdded;

	fetch(upsellCartUrl)
		.then((response) => response.text())
		.then((responseText) => {
			const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
			const upsellHtml = responseHTML.getElementById('shopify-section-tpt-upsell-cart');

			const upsellCartContent = document.getElementById('upsell-ajax-load');
			const upsellcartBottom = document.getElementById('cart-drawer_upsell-bottom');

			upsellCartContent.innerHTML = upsellHtml.innerHTML;

			/**
			 * Append upsell to mobile
			 */
			upsellcartBottom.innerHTML = upsellHtml.innerHTML;

			upsellcartBottom.querySelectorAll('.product-buttons').forEach((item) => {
				item.remove();
			});

			upsellcartBottom.querySelectorAll('.product-image-buttons').forEach((item) => {
				item.remove();
			});

			upsellCartContent.querySelectorAll('script').forEach((oldScriptTag) => {
				const newScriptTag = document.createElement('script');
				Array.from(oldScriptTag.attributes).forEach((attribute) => {
					newScriptTag.setAttribute(attribute.name, attribute.value);
				});
				newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
			});
		})
		.finally(() => {
			const checkItem = document.querySelector('#upsell-ajax-load .product-card-wrapper');

			if (!checkItem) {
				upsellNoProduct();
			}
		})
		.catch(() => {
			upsellNoProduct();
		});
}

/**
 * Update label sticky cart product page
 */

function updateStickyCartLabel() {
	if (document.querySelector('.sticky-button-cart') && document.querySelector('.main-product-section variant-selects')) {
		const productVariants = document.querySelectorAll('.main-product-section variant-selects fieldset.product-form__input');
		const variantLabelContainer = document.querySelectorAll('.sticky-cart_variants');

		variantLabelContainer.forEach((variantContent) => {
			variantContent.innerHTML = '';
		});

		productVariants.forEach((variant) => {
			const variantLabel = variant.querySelector('.form__label');
			variantLabelContainer.forEach((variantContent) => {
				variantContent.insertAdjacentHTML('beforeend', '<div class="variant-label">' + variantLabel.innerHTML + '</div>');
			});
		});
	}
}

updateStickyCartLabel();

/**
 * Upsell Minicart
 */

if (!customElements.get('tpt-upsell-minicart')) {
	customElements.define(
		'tpt-upsell-minicart',
		class TptUpsellCart extends HTMLElement {
			constructor() {
				super();

				if (document.querySelector('.cart-upsell-container') && document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty') == false && document.querySelector('.cart-drawer_upsell-bottom')) {
					upsellCartDrawer();
				}
			}
		}
	);
}

/**
 * Toggle password
 */

if (!customElements.get('tpt-toggle-password')) {
	customElements.define(
		'tpt-toggle-password',
		class TptTogglePassword extends HTMLElement {
			constructor() {
				super();
				this.addEventListener('click', this.togglePassword.bind(this));
				this.addEventListener('keydown', this.keyDown.bind(this));
			}

			keyDown(e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					this.togglePassword();
				}
			}

			togglePassword() {
				const wrapper = this.closest('.input-password');
				const input = wrapper?.querySelector('input');
				if (!input) return;
				const visible = input.type === 'password';
				input.type = visible ? 'text' : 'password';
				wrapper.classList.toggle('active', visible);
				this.setAttribute('aria-pressed', String(visible));
			}
		}
	);
}

/**
 * Slideshow scroll button
 */

class SlideShowScroll extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('click', this.slideScroll.bind(this));
		this.addEventListener('keypress', this.keyPress.bind(this));
	}

	keyPress(event) {
		if (event.key === 'Enter') {
			this.slideScroll();
		}
	}

	slideScroll() {
		const section = this.closest('.tpt-section');
		const scrollValue = section.offsetTop + section.offsetHeight;
		window.scrollTo({ top: scrollValue, behavior: 'smooth' });
	}
}

customElements.define('tpt-slideshow-scroll', SlideShowScroll);

/**
 * Section animation
 */

if (!customElements.get('tpt-animation-section')) {
	customElements.define(
		'tpt-animation-section',
		class TptAnimation extends HTMLElement {
			constructor() {
				super();

				this.elementRender = this.querySelector('[data-lazyload-element]');
			}

			connectedCallback() {
				const handleIntersection = (entries, observer) => {
					if (!entries[0].isIntersecting) return;
					observer.unobserve(this);

					setTimeout(() => {
						this.classList.add('tpt-animated');
					}, 500);
				};

				new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px -300px 0px' }).observe(this);
			}
		}
	);
}

(() => {
  const selector = '.tpt-horizontal-menu .horizontal-items > .menu-item.has-dropdown';
  const desktop = window.matchMedia('(min-width: 1025px)');
  let closeTimer;
  let activeItem = null;
  const state = (item, open) => {
    item.classList.toggle('show-dropdown', open);
    item.querySelector(':scope > a')?.setAttribute('aria-expanded', String(open));
  };
  const close = () => {
    clearTimeout(closeTimer);
    document.querySelectorAll(selector + '.show-dropdown').forEach(item => state(item, false));
    activeItem = null;
  };
  const open = item => {
    clearTimeout(closeTimer);
    document.querySelectorAll(selector + '.show-dropdown').forEach(other => {
      if (other !== item) state(other, false);
    });
    state(item, true);
    activeItem = item;
  };
  const init = () => {
    document.querySelectorAll(selector + ' > a').forEach(link => {
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', String(link.parentElement.classList.contains('show-dropdown')));
    });
  };
  document.addEventListener('pointerover', event => {
    if (!desktop.matches || event.pointerType !== 'mouse') return;
    const item = event.target.closest(selector);
    if (item) open(item);
    else if (event.target.closest('.tpt-horizontal-menu .menu-item')) close();
  });
  document.addEventListener('pointerout', event => {
    if (!desktop.matches || event.pointerType !== 'mouse' || !activeItem) return;
    if (!activeItem.contains(event.target) || activeItem.contains(event.relatedTarget)) return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, 300);
  });
  document.addEventListener('click', event => {
    if (!desktop.matches) return;
    const launcher = event.target.closest(selector + ' > a');
    if (launcher) {
      event.preventDefault();
      const item = launcher.parentElement;
      if (event.detail === 0 || event.pointerType === 'touch') {
        item.classList.contains('show-dropdown') ? close() : open(item);
      } else open(item);
      return;
    }
    if (!event.target.closest(selector)) close();
  });
  document.addEventListener('focusin', event => {
    if (!desktop.matches) return;
    const item = event.target.closest(selector);
    if (item && event.target !== item.querySelector(':scope > a')) open(item);
    else if (!item) close();
  });
  document.addEventListener('keydown', event => {
    if (!desktop.matches) return;
    const launcher = event.target.closest(selector + ' > a');
    if (launcher && [' ', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
      event.preventDefault();
      const item = launcher.parentElement;
      if (event.key === ' ') {
        item.classList.contains('show-dropdown') ? close() : open(item);
      } else {
        open(item);
        const links = [...item.querySelectorAll('.megamenu-dropdown a[href]')]
          .filter(link => link.getClientRects().length && getComputedStyle(link).visibility !== 'hidden');
        (event.key === 'ArrowDown' ? links[0] : links[links.length - 1])?.focus();
      }
      return;
    }
    if (event.key !== 'Escape' || !activeItem) return;
    const escapeLauncher = activeItem.querySelector(':scope > a');
    close();
    escapeLauncher?.focus();
  });
  document.addEventListener('shopify:section:load', init);
  desktop.addEventListener('change', close);
  init();
})();
